import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__content">
        <div className="footer__about">
          <h3>Artacode</h3>
          <p>
            Delivering excellence and innovation for your business needs. Let's shape the future together.
          </p>
        </div>
        <div className="footer__links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
        <div className="footer__social">
          <h4>Follow Us</h4>
          <div className="footer__social-icons">
            <a href="/"><i className="fab fa-facebook-f"></i></a>
            <a href="/"><i className="fab fa-twitter"></i></a>
            <a href="/"><i className="fab fa-linkedin-in"></i></a>
            <a href="/"><i className="fab fa-instagram"></i></a>
          </div>
        </div>
      </div>
      <div className="footer__bottom">
        <p>&copy; 2025 <a href="/">Artacode</a>. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
